import Trigger from 'eflex/models/trigger';

export default class LightGuideTrigger extends Trigger {}
